module.exports = __webpack_public_path__ + "static/preview-shoutcart@2x-7343344fcd3ef70122b931cdea380770.png";